// Hook to get total unread message count
// Used for badge display on Messages icon

import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import * as MessagingAPI from '@/lib/messaging-api';

export function useUnreadMessageCount() {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!user?.id) {
      setUnreadCount(0);
      return;
    }

    const fetchUnreadCount = async () => {
      try {
        // Get all users
        const users = await MessagingAPI.getOnlineUsers();
        
        // Calculate total unread from all users
        let total = 0;
        for (const otherUser of users) {
          if (otherUser.id !== user.id) {
            const count = await MessagingAPI.getUnreadCount(user.id, otherUser.id);
            total += count;
          }
        }
        
        setUnreadCount(total);
      } catch (error) {
        console.error('[useUnreadMessageCount] Error fetching unread count:', error);
        setUnreadCount(0);
      }
    };

    // Fetch immediately and then every 5 seconds
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 5000);

    return () => clearInterval(interval);
  }, [user?.id]);

  return unreadCount;
}
